import { TextStyle } from "@pixi/text";
import { getDefaultFontFamily } from "../../common/TextUtils";

export class GreenTextStyle extends TextStyle {
    constructor(fontSize: number = 150) {
        super({
            fontFamily: getDefaultFontFamily(),
            fontSize,
            fill: "#ffffff",
            stroke: "#00728E",
            strokeThickness: 15,
            lineJoin: "round",
            align: "center"
        });
    }
}

export class PinkTextStyle extends TextStyle {
    constructor(fontSize: number = 150) {
        super({
            fontFamily: getDefaultFontFamily(),
            fontSize,
            fill: "#ffffff",
            stroke: "#86008E",
            strokeThickness: 15,
            lineJoin: "round",
            align: "center"
        });
    }
}

export class YellowTextStyle extends TextStyle {
    constructor(fontSize: number = 150, strokeType: "green" | "pink" = "green") {
        super({
            fontFamily: getDefaultFontFamily(),
            fontSize,
            fill: "#FFFE82",
            stroke: strokeType === "green" ? "#00728E" : "#86008E",
            strokeThickness: 15,
            lineJoin: "round",
            align: "center"
        });
    }
}